import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';
import type { Dayjs } from 'dayjs';

import { AddToWalletButtons } from '../../AddToWalletButtons/AddToWalletButtons';
import { BarCode } from '../../BarCode/BarCode';
import { MplTicketValidity } from '../../MplTicketValidity';

import {
	MplDeutschlandTicketCardFooter,
	MplDeutschlandTicketCardHeader,
	MplDeutschlandTicketCardSeparator,
	MplDeutschlandTicketNameAndStatus,
	MplDeutschlandTicketRemainingTimeLeft,
	StyledBottomContainer,
	StyledCardContainer,
	StyledQRCodeWrapper,
	StyledTicketContainer,
	StyledTicketDetailsSection,
} from './components';

interface IMplDeutschlandTicketCardActiveProps {
	id: string;
	firstName: string;
	lastName: string;
	formattedPrice: string;
	ticketId: string;
	ticketAztecCode: string;
	validFrom: Dayjs;
	validUntil: Dayjs;
	timeLeft: Dayjs;
}

export const MplDeutschlandTicketCardActive: FC<
	IMplDeutschlandTicketCardActiveProps
> = ({
	id,
	firstName,
	lastName,
	formattedPrice,
	ticketId,
	ticketAztecCode,
	validFrom,
	validUntil,
	timeLeft,
}) => {
	const { t } = useTranslation('userDTicket');
	return (
		<StyledTicketContainer>
			<StyledCardContainer>
				<MplDeutschlandTicketCardHeader formattedPrice={formattedPrice} />
				<MplDeutschlandTicketCardSeparator />
				<StyledBottomContainer>
					<StyledTicketDetailsSection>
						<MplDeutschlandTicketNameAndStatus
							firstName={firstName}
							lastName={lastName}
							statusText={t('dticket_large.status.active')}
							statusVariant="success"
						/>
						<Stack gap={0.5}>
							<MplTicketValidity
								validityLabel={t('dticket_large.validity')}
								validFrom={validFrom}
								validUntil={validUntil}
							/>

							<MplDeutschlandTicketRemainingTimeLeft
								endDate={timeLeft}
								isPreordered={false}
							/>
						</Stack>
					</StyledTicketDetailsSection>
					<StyledQRCodeWrapper>
						<BarCode
							id={ticketId}
							type="azteccode"
							textToEncode={window.atob(ticketAztecCode)}
						/>
					</StyledQRCodeWrapper>
					<MplDeutschlandTicketCardFooter ticketId={ticketId} />
					{id && <AddToWalletButtons ticketId={id} />}
				</StyledBottomContainer>
			</StyledCardContainer>
		</StyledTicketContainer>
	);
};
